import React, { useState, useEffect } from 'react';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { get, isNull, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import EventFAQ from 'shared-components/faq/EventFAQ';
import { Listings } from '../../../api/api-listings';
import { PageSpinner } from '../shared-components/decorators/spinner';
import EventFAQContext from '../shared-components/faq/data/EventFAQContext';

const EventFAQModal = ({ faqData, showModal, toggleModal, listingId, intl }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [productionDataLoaded, setProductionDataLoaded] = useState(false);
  const [parkingInfo, setParkingInfo] = useState(null);
  const [hostRules, setHostRules] = useState(null);

  useEffect(()=>{
    if (showModal && !productionDataLoaded) {
      setIsLoading(true);
      Listings.read(listingId, (res)=>{
        const parkingData = get(res, 'parking_info', {});
        const listingRules = get(res, 'rules', '');
        const minAge = get(res, 'min_age');
        const surveillance = get(res, 'surveillance_info', {});
        const surveillanceDescription = get(surveillance, 'description', null);
        const hasSurveillance = get(surveillance, 'has_surveillance', null);
        const surveillanceText = defineMessages({
          has_surveillance: {
            id: 'listing.listing_main.has_surveillance',
            defaultMessage: 'Security cameras and recording devices'
          },
          surveillance_description: {
            id: 'listing.lisitng_main.surveillance_description',
            defaultMessage: 'Check with your host if there are any surveillance cameras or recording devices in the space.'
          }
        });
        setHostRules({
          min_age: minAge,
          rules: listingRules,
          has_surveillance: (isNull(hasSurveillance) || true === hasSurveillance) &&
            intl.formatMessage(surveillanceText.has_surveillance),
          surveillance_description: isNull(hasSurveillance) ?
            intl.formatMessage(surveillanceText.has_surveillance) :
            surveillanceDescription,
          listingID: listingId
        });
        setIsLoading(false);
        setParkingInfo(parkingData);
        setProductionDataLoaded(true);
      });
    }
  }, [showModal]);

  return (
    <BootstrapModal
      addCloseIcon
      modalClass="EventFAQModal"
      modalSize="md-size"
      headerClass="padding-no-top border-bottom-gray-200"
      header={<div>
        <div className="text-left no-margin h3">
          <FormattedMessage id="inquiry_booking.booking_summar_listing.event_faq_header" defaultMessage="Event FAQ" />
        </div>
        <p className="text-left text-small text-gray-dark no-margin">
          <FormattedMessage
            id="inquiry_booking.booking_summar_listing.event_faq_subheader"
            defaultMessage="More details about this space"
          />
        </p>
      </div>}
      bodyClass="padding-no-top"
      body={(
        <div className="modal-content">
          {isLoading ? (
            <div style={{ minHeight: '100px' }}>
              <PageSpinner additionalStyle='gray' />
            </div>
          ) : (
            <EventFAQContext.Provider value={{ popOverIndex: 9000 }}>
              <EventFAQ faqData={faqData} parkingInfo={parkingInfo} hostRules={hostRules} popOverIndex={9000} />
            </EventFAQContext.Provider>
          )}
        </div>
      )}
      allowClickAway
      showModal={showModal}
      toggleModal={toggleModal}
    />
  );
};

EventFAQModal.propTypes = {
  faqData: PropTypes.object,
  showModal: PropTypes.bool,
  accessToken: PropTypes.string,
  toggleModal: PropTypes.func,
  listingId: PropTypes.string
};

export default injectIntl(EventFAQModal);
